var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMagnifierWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7601 18.8976L16.4643 15.6017C17.6282 14.2155 18.2121 12.4336 18.0942 10.6274C17.9763 8.82129 17.1657 7.13037 15.8315 5.9073C14.4972 4.68422 12.7424 4.02342 10.9328 4.06269C9.12323 4.10196 7.39867 4.83827 6.11875 6.11807C4.83884 7.39787 4.10238 9.12237 4.06295 10.9319C4.02352 12.7415 4.68417 14.4964 5.90712 15.8308C7.13008 17.1651 8.82093 17.9758 10.6271 18.0939C12.4332 18.2119 14.2152 17.6282 15.6014 16.4644L18.8974 19.7603C19.0118 19.8747 19.1669 19.939 19.3287 19.939C19.4905 19.939 19.6457 19.8747 19.7601 19.7603C19.8745 19.6459 19.9388 19.4908 19.9388 19.329C19.9388 19.1672 19.8745 19.012 19.7601 18.8976ZM5.29846 11.0935C5.29846 9.94726 5.63835 8.8268 6.27515 7.87376C6.91194 6.92073 7.81704 6.17793 8.876 5.7393C9.93495 5.30067 11.1002 5.1859 12.2244 5.40952C13.3485 5.63313 14.3812 6.18508 15.1917 6.99556C16.0021 7.80605 16.5541 8.83867 16.7777 9.96285C17.0013 11.087 16.8866 12.2523 16.4479 13.3112C16.0093 14.3702 15.2665 15.2753 14.3135 15.9121C13.3604 16.5489 12.24 16.8888 11.0938 16.8888C9.55729 16.887 8.08424 16.2759 6.99778 15.1894C5.91133 14.103 5.3002 12.6299 5.29846 11.0935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagnifierWhite);
export default __webpack_public_path__ + "static/media/icon-magnifier-white.774a3f1bf3d67e02c6dee8c9a631819c.svg";
export { ForwardRef as ReactComponent };